module.exports = __webpack_public_path__ + "media/trzmiel.d4dabc59.mp4";